import { useEffect, useRef } from "react";

export const useClearSensitiveRefsOnPageHide = (...sensitiveRefs) => {
    const sensitiveRefsRef = useRef(sensitiveRefs);
    sensitiveRefsRef.current = sensitiveRefs;

    useEffect(() => {
        const clearSensitiveRefs = () => {
            sensitiveRefsRef.current.forEach((sensitiveRef) => {
                if (sensitiveRef && Object.prototype.hasOwnProperty.call(sensitiveRef, "current")) {
                    sensitiveRef.current = null;
                }
            });
        };

        window.addEventListener("pagehide", clearSensitiveRefs);
        return () => {
            window.removeEventListener("pagehide", clearSensitiveRefs);
            clearSensitiveRefs();
        };
    }, []);
};
